var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUrbanobject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#DFF1FF"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4E2E4"
    },
    d: "M511.863,248c-0.736-23.962-4.759-47.095-11.644-68.962C483.342,172.012,453.662,160,448,160 c-8,0-48,24-56,24s-88-48-96-48s-56,24-64,24s-24-16-40-16s-56.129,30.569-64,32c-11,2-40-16-56-16 c-11.373,0-42.935,12.118-60.25,19.131C4.884,200.971,0.871,224.072,0.137,248H511.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8AC5CA"
    },
    d: "M272,240c-8,0-80-32-88-32s-32,16-40,16s-48-24-64-24c-11.043,0-52.569,11.431-77.241,18.515 C0.963,230.753,0,243.263,0,256c0,5.379,0.221,10.704,0.548,16h510.904c0.327-5.296,0.548-10.621,0.548-16 c0-7.059-0.363-14.03-0.924-20.945C475.469,228.03,413.666,216,408,216C400,216,280,240,272,240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DB195"
    },
    d: "M499.18,336c8.279-25.178,12.82-52.052,12.82-80H0c0,27.948,4.541,54.822,12.82,80H499.18z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 139.76,
    y: 136,
    style: {
      fill: "#F5F0F0"
    },
    width: 4.706,
    height: 56.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.41,
    y: 211.29,
    style: {
      fill: "#F5F0F0"
    },
    width: 9.412,
    height: 84.71
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 136.32,
    y: 201.88,
    style: {
      fill: "#B4B9C8"
    },
    width: 11.593,
    height: 11.361
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B4B9C8"
    },
    points: "145.261,178.353 138.974,178.353 135.059,201.882 149.176,201.882  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F09B8C"
    },
    points: "156.235,192 128,192 128,201.882 136,208 148,208 156.235,201.882 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 248,
    style: {
      fill: "#FAF0DC"
    },
    width: 80,
    height: 72
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B4B9C8"
    },
    d: "M464,384h13.667C499.463,346.337,512,302.646,512,256h-48V384z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 272,
    style: {
      fill: "#AA9191"
    },
    width: 72,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 264,
    style: {
      fill: "#AAC3DC"
    },
    width: 40,
    height: 96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 264,
    style: {
      fill: "#F0CDB4"
    },
    width: 32,
    height: 96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 280,
    style: {
      fill: "#82A5CD"
    },
    width: 48,
    height: 96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 248,
    style: {
      fill: "#B4B9C8"
    },
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 216,
    style: {
      fill: "#FAF0DC"
    },
    width: 56,
    height: 120
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 320,
    style: {
      fill: "#FFFFFF"
    },
    width: 72,
    height: 48
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 280,
    style: {
      fill: "#968282"
    },
    width: 48,
    height: 88
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA9191"
    },
    d: "M496,345.203V272h-40v143.712C472.833,394.661,486.437,370.923,496,345.203z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 232,
    style: {
      fill: "#82A5CD"
    },
    width: 64,
    height: 144
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 280,
    style: {
      fill: "#AA9191"
    },
    width: 40,
    height: 120
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 264,
    style: {
      fill: "#EBE1C3"
    },
    width: 56,
    height: 120
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 216,
    style: {
      fill: "#B4B9C8"
    },
    width: 40,
    height: 168
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 176,
    style: {
      fill: "#82A5CD"
    },
    width: 64,
    height: 216
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 336,
    style: {
      fill: "#FFFFFF"
    },
    width: 72,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73BE6E"
    },
    d: "M25.764,368C67.312,453.248,154.786,512,256,512s188.688-58.752,230.236-144H25.764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6EAA64"
    },
    d: "M224.631,509.95C185.333,481.333,187.333,460,208,446.667c26.543-17.124,78.019-13.552,104-38.667 c20-19.333,83-24,165.7-23.989c3.024-5.226,5.88-10.561,8.537-16.011H25.764C62.946,444.291,136.954,499.219,224.631,509.95z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 328,
    style: {
      fill: "#FAF0DC"
    },
    width: 32,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 320,
    style: {
      fill: "#F0CDB4"
    },
    width: 32,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 288,
    style: {
      fill: "#FAF0DC"
    },
    width: 40,
    height: 72
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B4B9C8"
    },
    d: "M22.086,360H48v-64H3.131C6.653,318.443,13.132,339.892,22.086,360z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6EAA64"
    },
    d: "M455.707,415.978c-35.707-1.978-75.949,2.393-97.04,7.355C330.333,430,326,443.667,288,453.333 c-39.516,10.052-30.517,39.857-7.563,57.373C351.238,503.988,413.588,468.497,455.707,415.978z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#558C73"
    },
    d: "M209.368,392h89.298c0,0-5.167-25-44.667-25c0,0-20-17-43-9.5c0,0-8.5-7-27.5-1.5 c0,0-22-6.5-40.5,4.5c0,0-10.5-10-24-5.5c0,0-21.5-5-33.5,4.5c0,0-12.5-12.5-38.5-9.5c0,0-14.341-9.686-32.372-8.655 C20.952,359.231,29.21,376.19,39.147,392h31.371c-3.9,2.428-6.518,6.721-6.518,11.655h51.103c0-4.381-1.483-8.387-3.906-11.655 h51.407c-0.052,0.072-0.119,0.132-0.169,0.206c-4.909,0.49-9.293,2.707-12.47,6.137c-1.065-0.265-2.162-0.446-3.309-0.446 c-7.598,0-13.758,6.16-13.758,13.758H184c0-4.381-1.483-8.387-3.906-11.655h31.009C211.103,397.144,210.463,394.448,209.368,392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#558C73"
    },
    d: "M492.684,353.613c-36.684-9.613-70.856-1.079-70.856-1.079c-24.616-3.956-46.022,5.011-46.022,5.011 c-42.276,0-47.805,13.188-47.805,13.188h156.835C487.648,365.136,490.28,359.435,492.684,353.613z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrbanobject);
export default __webpack_public_path__ + "static/media/urbanobject.547ae8a6a90bbaf57a47024e58f4dec8.svg";
export { ForwardRef as ReactComponent };